module.exports = __webpack_public_path__ + "static/download-jumbotron-image-f18c2cb5ef856ca4ca6e6bdbccd95c46.png";